import { StyleSheet, View } from "react-native";
import React from "react";
import { Txt } from "./TextsComponents";
import DimensionsHook from "../hooks/DimensionsHook";
import { colors } from "../styles/GlobalStyle";
import { useTranslation } from "react-i18next";

const Footer = () => {
  const { t } = useTranslation();
  const { isDesktop } = DimensionsHook();
  return (
    <View style={styles.footer}>
      <View
        style={{
          width: isDesktop ? "85%" : "95%",
          borderTopWidth: 1,
          backgroundColor: colors.white,
          borderTopColor: colors.grayBorder,
          alignItems: "center",
          justifyContent: "center",
          height: 70,
        }}
      >
        <Txt fontSize={14}>{t("footer")}</Txt>
      </View>
    </View>
  );
};

export default Footer;

const styles = StyleSheet.create({
  footer: {
    backgroundColor: colors.white,

    alignItems: "center",
    justifyContent: "center",
  },
});
